import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20Korean%20manhwa%20style%20illustration%20background%20with%20warm%20golden%20and%20coral%20color%20gradients%2C%20soft%20flowing%20shapes%20reminiscent%20of%20ink%20wash%20painting%2C%20elegant%20and%20dreamy%20atmosphere%2C%20subtle%20comic%20panel%20textures%2C%20no%20text%2C%20artistic%20and%20refined&width=1800&height=900&seq=hero-bg-korean-comic&orientation=landscape"
        alt="韩漫免费阅读 - 韩漫画网"
        className="w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-[800px] mx-auto text-center px-4">
          <h1 className="text-3xl md:text-5xl font-bold font-heading text-white leading-tight">
            下拉式完整版韩漫免费阅读
          </h1>
          <p className="mt-4 md:mt-6 text-base md:text-lg text-white/80 max-w-[600px] mx-auto leading-relaxed">
            韩漫画网 —— 您的韩漫大全阅读伴侣。无删减漫画免费阅读，每日更新，
            恋爱、奇幻、动作、剧情等各类韩漫应有尽有，确保您总有新书可看。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/all"
              className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              开始阅读
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/15 text-white font-medium rounded-lg hover:bg-white/25 backdrop-blur-sm transition-colors whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}